import * as schemas from "~/schemas/schema.availability_types.jsx";
import * as actionTypes from "~/store/action_types";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";

export const url = `availability-types`;

export const addAvailabilityType = (attributes) => {
  return {
    types: [
      actionTypes.ADD_AVAILABILITY_TYPE_LOADING,
      actionTypes.ADD_AVAILABILITY_TYPE_SUCCESS,
      actionTypes.ADD_AVAILABILITY_TYPE_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/${url}`,
        method: `post`,
        body: attributes,
      }),
    payload: {
      attributes,
      schema: {
        single: schemas.availabilityType,
      },
    },
  };
};

export const editAvailabilityType = (availabilityTypeId, attributes) => {
  return {
    types: [
      actionTypes.EDIT_AVAILABILITY_TYPE_LOADING,
      actionTypes.EDIT_AVAILABILITY_TYPE_SUCCESS,
      actionTypes.EDIT_AVAILABILITY_TYPE_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/${url}/${availabilityTypeId}`,
        method: `put`,
        body: attributes,
      }),
    payload: {
      availabilityTypeId,
      attributes,
      schema: {
        single: schemas.availabilityType,
      },
    },
  };
};

export const getAvailabilityType = (availabilityTypeId) => {
  return {
    types: [
      actionTypes.FETCH_AVAILABILITY_TYPES_LOADING,
      actionTypes.FETCH_AVAILABILITY_TYPES_SUCCESS,
      actionTypes.FETCH_AVAILABILITY_TYPES_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/${url}/${availabilityTypeId}`,
      }),
    payload: {
      availabilityTypeId,
      schema: {
        single: schemas.availabilityType,
      },
    },
  };
};

export const getAvailabilityTypes = () => {
  return {
    types: [
      actionTypes.FETCH_AVAILABILITY_TYPES_LOADING,
      actionTypes.FETCH_AVAILABILITY_TYPES_SUCCESS,
      actionTypes.FETCH_AVAILABILITY_TYPES_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/${url}`,
      }),
    payload: {
      schema: schemas.arrayOfAvailabilityTypes,
    },
  };
};

export const deleteAvailabilityType = (availabilityTypeId) => {
  return {
    types: [
      actionTypes.DELETE_AVAILABILITY_TYPE_LOADING,
      actionTypes.DELETE_AVAILABILITY_TYPE_SUCCESS,
      actionTypes.DELETE_AVAILABILITY_TYPE_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/${url}/${availabilityTypeId}`,
        method: `DELETE`,
      }),
    payload: {
      id: availabilityTypeId,
    },
  };
};

export const availabilityTypeCreatedFromEventStream = (data) => {
  return {
    type: actionTypes.ADD_AVAILABILITY_TYPE_FROM_EVENT_STREAM_SUCCESS,
    response: data,
    schema: schemas.availabilityType,
  };
};

export const availabilityTypeUpdatedFromEventStream = (data) => {
  return {
    type: actionTypes.EDIT_AVAILABILITY_TYPE_FROM_EVENT_STREAM_SUCCESS,
    response: data,
    schema: schemas.availabilityType,
    availabilityTypeId: data.id,
  };
};

export const availabilityTypeDeletedFromEventStream = (data) => {
  return {
    type: actionTypes.DELETE_AVAILABILITY_TYPE_FROM_EVENT_STREAM_SUCCESS,
    id: data.id,
  };
};
